import React from "react";
import uploadIcon from "../../assets/images/icons/upload.png";

const UploadedBanner = ({ defaultImage }) => {
  return (
    <div className="mb-3">
      <label htmlFor="Category" className="form-label">
        Banner
      </label>
      <div className="file-upload">
        {defaultImage ? (
          <img
            src={defaultImage}
            alt="Uploaded Banner"
            className="img-fluid"
            loading="lazy" 
          />
        ) : (
          <section>
            <img
              src={uploadIcon}
              alt="Upload Icon"
              loading="lazy" 
            />
            <span>Upload Banner</span>
          </section>
        )}
      </div>
    </div>
  );
};

export default UploadedBanner;
